import { Reveal } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

const LOGOS = [
  { src: "/logos/emaar.svg", alt: "Emaar" },
  { src: "/logos/meraas.svg", alt: "Meraas" },
  { src: "/logos/sobha.svg", alt: "Sobha Realty" },
  { src: "/logos/damac.svg", alt: "DAMAC" },
  { src: "/logos/select.svg", alt: "Select Group" },
  { src: "/logos/ellington.svg", alt: "Ellington Properties" },
  { src: "/logos/nshama.svg", alt: "Nshama" },
  { src: "/logos/dubaisouth.svg", alt: "Dubai South" },
];

export const DeveloperLogos = () => {
  const { t } = useI18n();
  return (
    <section className="py-16 sm:py-20" data-testid="developer-logos">
      <div className="container-x">
        <Reveal>
          <p className="text-center text-xs font-medium uppercase tracking-[0.22em] text-muted">{t.logos.trusted}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 grid grid-cols-2 items-center gap-x-8 gap-y-10 sm:grid-cols-4 lg:grid-cols-8">
            {LOGOS.map((l) => (
              <div key={l.alt} className="flex items-center justify-center" data-testid={`dev-logo-${l.alt.toLowerCase().replace(/\s/g, "-")}`}>
                <img src={l.src} alt={l.alt} loading="lazy" className="h-6 w-auto max-w-[120px] object-contain opacity-50 grayscale transition-[opacity,filter] duration-300 hover:opacity-100 hover:grayscale-0 sm:h-7" />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
